import { Fragment, useState } from 'react';
import { ResentEmailEnum, SignatoryStatus } from 'app-constants';
import classNames from 'classnames';
import { Col, Row } from 'components-antd';
import moment from 'moment';

import { Signatory } from 'components/Icons/Signatory';
import { Icons, ICON_VARIANT_TYPE } from 'pages/Workshop/Forms/Icons';

import { getSignatoryStatus, getViewDate } from '../../../../helper';

import styles from '../styles.module.scss';
import { TrackingHeadTitle } from '../TrackingHeadTitle';
import { momentRelativeTime } from '../helper';
import { FormUserDropdown } from '../components/FormUserDropdown';

// Define a custom locale (e.g., 'en-short')
moment.defineLocale('en-short', {
  parentLocale: 'en',
  relativeTime: momentRelativeTime,
});

export const FormSignatories = (props) => {
  const {
    agents,
    clients,
    viewOnly,
    isDraftForm,
    formDetails,
    handleMessage,
    isAdminOrOwner,
    handleResendForm,
    isWaitingOnYouForm,
    setReplaceEntityModal,
  } = props;

  const [hoveredEmail, setHoveredEmail] = useState(null);

  if (!formDetails.signatories?.length) return null;

  const { isCompleted, signatories, isVoid, isSequential } = formDetails;

  const showDropdown = (value) => {
    return (!viewOnly && !isVoid) || (viewOnly && isAdminOrOwner && value.allowResend && !isVoid);
  };

  return (
    <Fragment>
      {!isCompleted && <TrackingHeadTitle title={'Signatories'} />}

      <div className={styles.trackingTabItems}>
        {signatories.map((val, index) => {
          const { name, email, isYou, userId, declineMessage, status, avatar } = val;

          const isDeclined = status === SignatoryStatus.Declined;
          const isPending = status === SignatoryStatus.Pending;
          const isSigned = status === SignatoryStatus.Signed;
          const isRequested = status === SignatoryStatus.Requested;
          const isVoided = isVoid;

          const signatoryStatus = isDraftForm ? 'Not Sent' : getSignatoryStatus(val, formDetails);
          const isViewed = signatoryStatus === SignatoryStatus.Viewed;

          const showDuration = !isVoided && !isDraftForm;
          const canDropdown = showDropdown(val);
          return (
            <div
              className={classNames(styles.signatoriesRow, {
                [styles.sequentialUsersRow]: isSequential && signatories.length > 1,
                [styles.dropdownSignatoriesRow]: canDropdown,
              })}
              onMouseEnter={() => canDropdown && setHoveredEmail(email)}
              onMouseLeave={() => canDropdown && setHoveredEmail(null)}
              key={index}
            >
              <Row className={classNames(styles.formUsersRow, styles.avatarWrapper)}>
                <div className={styles.info}>
                  <Col
                    className={styles.signatureCountRow}
                    style={
                      isSequential ? { zIndex: index + 1, backgroundColor: '#fff' } : undefined
                    }
                  >
                    <div
                      className={classNames({
                        [styles.pendingSignature]: isPending && isSequential && !isDraftForm,
                      })}
                    >
                      {isDraftForm ? (
                        <Signatory />
                      ) : isSigned || isViewed ? (
                        <Icons
                          variant={isViewed ? ICON_VARIANT_TYPE.VIEWED : ICON_VARIANT_TYPE.SIGNED}
                        />
                      ) : isDeclined && !isSequential ? (
                        <Icons variant={ICON_VARIANT_TYPE.DECLINED} />
                      ) : (
                        <Signatory {...(isWaitingOnYouForm && isYou && { stroke: '#EC455E' })} />
                      )}
                    </div>
                  </Col>

                  <Col>
                    <p className={styles.usersName}>{isYou ? 'You' : name}</p>
                  </Col>
                </div>

                <div className={styles.itemAction}>
                  <div className={styles.status}>
                    <p
                      className={
                        ((isPending || isRequested || isVoided) && !isViewed && !isDraftForm) ||
                        (isDeclined && !isSequential)
                          ? styles.colorClass
                          : ''
                      }
                    >
                      {`${signatoryStatus} `}
                      {showDuration && status[0] !== 'W' && val.date && (
                        <span>
                          {moment(isViewed ? getViewDate(email, formDetails) : val.date).fromNow()}
                        </span>
                      )}
                    </p>

                    {canDropdown && (
                      <div
                        className={styles.dropdownOptionWrapper}
                        style={{ display: hoveredEmail === email ? 'flex' : 'none' }}
                      >
                        <div className={styles.optionBackground} />
                        <FormUserDropdown
                          emailAddresss={email}
                          messageData={{
                            id: userId,
                            name,
                            avatar,
                          }}
                          allowResend={val.allowResend}
                          allowReplace={val.allowReplace}
                          allowMessage={Boolean(userId) && !isYou && !viewOnly}
                          onResend={() =>
                            handleResendForm({
                              url: formDetails?.formDocument?.url,
                              userId,
                              email,
                              type: ResentEmailEnum.signature,
                            })
                          }
                          onReplace={() =>
                            setReplaceEntityModal({
                              open: true,
                              isEditor: false,
                              entityId: val.signatoryId,
                              name,
                              email,
                              role: val.role,
                              options: [...(agents || []), ...(clients || [])],
                            })
                          }
                          resendText={isCompleted ? 'Resend a Copy' : 'Resend'}
                          onMessage={handleMessage}
                          key={hoveredEmail === email ? `${email}-open` : `${email}-closed`}
                          shouldHide={hoveredEmail !== email}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </Row>

              {isDeclined && declineMessage && (
                <div
                  className={classNames(styles.declinedReason, {
                    [styles.sequentialDeclineReason]:
                      isSequential && index < signatories.length - 1,
                  })}
                >
                  {declineMessage}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </Fragment>
  );
};
